import { render, staticRenderFns } from "./ProjectShowDetailsTab.vue?vue&type=template&id=2e25f0a6"
import script from "./ProjectShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports